module.exports = __webpack_public_path__ + "static/img/dialog4.d0c090f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dialog4.jpg
// module id = /SEU
// module chunks = 159